'use strict';

/**
 * Dependencies
 */
var _require = require('json-document'),
    JSONSchema = _require.JSONSchema;

/**
 * Base64URLSchema
 */


var Base64URLSchema = new JSONSchema({
  type: 'string',
  format: 'base64url'
});

/**
 * Export
 */
module.exports = Base64URLSchema;


//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/jose/lib/schemas/Base64URLSchema.js
// module id = 128
// module chunks = 0